import {
  FETCH_PEAK_TODAY_REQUEST,
  FETCH_PEAK_TODAY_SUCCESS,
  FETCH_PEAK_TODAY_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const peakTodayReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_PEAK_TODAY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PEAK_TODAY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_PEAK_TODAY_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default peakTodayReducer;
